// extracted by mini-css-extract-plugin
export var closeButton = "_2l-3";
export var header = "_2l-0";
export var link = "_2l-1";
export var retryButton = "_2l-2";